module.exports = __webpack_public_path__ + "img/Images reseaux sociaux gif.77e01524.png";